export const ShowMoreTextWrapperTestIds = {
  TOGGLE_BUTTON: 'show-more-text.toggle-button',
};
